import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Select from 'react-select';

interface BrokerSpecialty {
  id: number;
  title: string;
  propertyType: string;
}

// Represents the shape expected by react-select component (value/label format)
// Transformed from BrokerSpecialty for use in the dropdown and component state
interface SpecialtyOption {
  value: number;
  label: string;
}

interface CompanySpecialty {
  id: number;
  brokerSpecialtyId: number;
  propertyType: string;
}

export interface SpecialtiesProps {
  allBrokerSpecialties: BrokerSpecialty[];
  companySpecialties: CompanySpecialty[];
}

function initialSpecialtiesSelected(
  specialtiesOptions: SpecialtyOption[],
  companySpecialties: CompanySpecialty[]
): SpecialtyOption[] {
  const selectedBrokerSpecialtyId = companySpecialties.map(s => s.brokerSpecialtyId);
  return specialtiesOptions.filter(o => selectedBrokerSpecialtyId.includes(o.value));
}

export default function Specialties({
  allBrokerSpecialties,
  companySpecialties
}: SpecialtiesProps) {
  const specialtiesOptions = allBrokerSpecialties.map(a => ({ value: a.id, label: a.title }));
  const [selectedSpecialties, setSelectedSpecialties] = useState<SpecialtyOption[]>(
    () => initialSpecialtiesSelected(specialtiesOptions, companySpecialties)
  );

  const selectedSpecialtyIds = selectedSpecialties.map(s => s.value);
  const persistedBrokerSpecialties = companySpecialties.map(s => s.brokerSpecialtyId);
  const newSpecialtyIds = selectedSpecialtyIds.filter(id =>
    !persistedBrokerSpecialties.includes(id)
  );

  return (
    <>
      <h3 className="top-buffer-lg">Specialties</h3>
      <Row className="form-group">
        <Col md={6}>
          <Select
            classNamePrefix="react-select-buildout"
            isMulti
            options={specialtiesOptions}
            value={selectedSpecialties}
            onChange={(value) => setSelectedSpecialties(value as SpecialtyOption[])}
          />
        </Col>
      </Row>

      {companySpecialties.map((companySpecialty, index) => {
        const isSelected = selectedSpecialtyIds.includes(companySpecialty.brokerSpecialtyId);

        return (
          <React.Fragment key={companySpecialty.id}>
            <input name={`company[company_broker_specialties_attributes][${index}][id]`} type="hidden" value={companySpecialty.id}/>
            <input
              name={`company[company_broker_specialties_attributes][${index}][broker_specialty_id]`}
              type="hidden"
              value={companySpecialty.brokerSpecialtyId}
            />
            <input
              name={`company[company_broker_specialties_attributes][${index}][_destroy]`}
              type="hidden"
              value={!isSelected ? 'true' : 'false'}
            />
          </React.Fragment>
        );
      })}

      {newSpecialtyIds.map((specialtyId, i) => {
        const index = i + companySpecialties.length;

        return (
          <React.Fragment key={specialtyId}>
            <input
              name={`company[company_broker_specialties_attributes][${index}][broker_specialty_id]`}
              type="hidden"
              value={specialtyId}
            />
          </React.Fragment>
        );
      })}
    </>
  );
}
